import React from "react";

const MyProfile = () => {
	return (
		<div>
			<h1>My profile</h1>
		</div>
	);
};

export default MyProfile;
